import React, { useState } from "react";
import PPEConsole from "./SimulationPPEConsole";
interface CapacityOffer {
  start_date: string;
  end_date: string;
  source_type: string;
  id: number;
  source_id: number;
  plant_capacity: string;
  plf: string;
  variable_charge: string;
  fixed_charge: string;
  status?: boolean;
  offerType: "capacity";
}

interface BatteryOffer {
  start_date: string;
  end_date: string;
  id: number;
  battery_id: number;
  battery_capacity_in_mwh: number;
  chargingRate: string;
  vc: string;
  fc: string;
  status?: boolean;
  offerType: "battery";
}

type CombinedOffer = CapacityOffer | BatteryOffer;

interface PPEFormData {
  startDate: string;
  endDate: string;
  scenario: string;
  offers: CombinedOffer[];
}

interface PPEConsoleTableProps {
  open: boolean;
  setOpen: any;
  setError?: any;
  refreshKey: any;
  setRefreshKey: any;
  onScenarioComparisonApply: (data: any) => void;
  selectedScenarios: Array<{ scenario_id: number; scenario_number: number }>;
}

export default function PPEConsoleTable({
  open,
  setOpen,
  setError,
  refreshKey,
  setRefreshKey,
  onScenarioComparisonApply,
  selectedScenarios,
}: PPEConsoleTableProps) {
  const [loading, setLoading] = useState(false);

  const handleApply = async (ppeData: PPEFormData) => {
    setLoading(true);
    try {


      // Call parent handler to update selectedScenarios state
      onScenarioComparisonApply(ppeData);

      // Close the panel
      setOpen(!open);
    } catch (error) {
      console.error("Error submitting data", error);
      if (setError) setError("Error submitting data");
    } finally {
      setLoading(false);
    }
  };

  const handleReset = () => {
    // Reset logic if needed
  };

  return (
    <div
      className="gas-chart-container simulation_table shadow-[rgba(149,157,165,0.2)_0px_8px_24px] bg-[#FFF] !p-0 overflow-hidden"
      id="slide"
      style={{
        width: "21%",
        position: "relative",
        zIndex: "2",
        height: "calc(-195px + 100vh)",
        transition: "all 0.3s ease-out",
      }}
    >
      <PPEConsole
        loading={loading}
        onApply={handleApply}
        onReset={handleReset}
        refreshKey={refreshKey}
        isSliderOpen={!open}
        setRefreshKey={setRefreshKey}
        onRefreshAllComponents={() => setRefreshKey((prev: number) => prev + 1)}
        selectedScenarios={selectedScenarios}
      />
    </div>
  );
}